import { render, staticRenderFns } from "./list2.vue?vue&type=template&id=a7144bd6&scoped=true&"
import script from "./list2.vue?vue&type=script&lang=js&"
export * from "./list2.vue?vue&type=script&lang=js&"
import style0 from "./list2.css?vue&type=style&index=0&id=a7144bd6&scoped=true&lang=css&"
import style1 from "./list2.vue?vue&type=style&index=1&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7144bd6",
  null
  
)

export default component.exports